import React from 'react';
import { Tag } from 'antd';

const getScoreColor = (score) => {
  const num = Number(score);
  if (num >= 4) return 'green';
  if (num >= 3) return 'orange';
  if (num >= 1) return 'red';
  return 'default';
};

export function getMainColumns() {
  return [
    {
      dataIndex: 'created_on',
      title: 'Дата оценки',
      width: 160,
      fixed: 'left',
    },
    {
      dataIndex: 'number',
      title: 'Номер талона',
      width: 150,
      align: 'center',
    },
    {
      dataIndex: 'fio',
      title: 'ФИО сотрудника',
      width: 250,
    },
    {
      dataIndex: 'answerdata',
      title: 'Средняя оценка',
      width: 150,
      align: 'center',
      render: (_, record) => {
        const score = record?.answerdata?.qround || '0.00';
        return (
          <Tag color={getScoreColor(score)} style={{ fontSize: 14, padding: '2px 12px' }}>
            {score}
          </Tag>
        );
      },
    },
  ];
}

const getAnswerColor = (weight) => {
  const color = getScoreColor(weight);
  if (color === 'green') return '#52c41a';
  if (color === 'orange') return '#faad14';
  if (color === 'red') return '#f5222d';
  return '#333';
};

export const getExpandedRow = (questionList, showWeight) => function (record) {
  const { answerdata } = record;
  if (!answerdata || !questionList || questionList.length === 0) {
    return <p style={{ color: '#999' }}>Нет данных по ответам</p>;
  }

  return (
    <div style={{ padding: '8px 16px' }}>
      {questionList
        .filter((q) => answerdata[q[0]] && typeof answerdata[q[0]] === 'object')
        .map((q) => {
          const qId = q[0];
          const qText = q[1];
          const answer = answerdata[qId];
          const textValue = answer.answertxt || answer.answerint;

          let answerDisplay;
          if (textValue && showWeight) {
            answerDisplay = `${textValue} (${answer.weight})`;
          } else if (textValue) {
            answerDisplay = String(textValue);
          } else {
            answerDisplay = String(answer.weight || '—');
          }

          return (
            <div
              key={qId}
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                padding: '6px 0',
                borderBottom: '1px solid #f0f0f0',
              }}
            >
              <span style={{ fontWeight: 500, color: '#333', flex: 1 }}>{qText}</span>
              <span style={{
                minWidth: 120,
                textAlign: 'right',
                fontWeight: 600,
                color: getAnswerColor(answer.weight),
              }}
              >
                {answerDisplay}
              </span>
            </div>
          );
        })}
    </div>
  );
};
